import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobFormComponent } from './job-form.component';
import { SharedModule } from 'app/shared/shared.module';
import { DataPickerModule } from 'app/components/data-picker/data-picker.module';
import { RecurrenceScheduleModule } from 'app/components/recurrence-schedule/recurrence-schedule.module';
import { PreviewAddressFormModule } from 'app/components/preview-address-form/preview-address-form.module';
import { NewCategoryModule } from 'app/components/new-category/new-category.module';
import { AddressModule } from 'app/components/address-component/address.component.module';
import { ServiceTaskFormModule } from 'app/components/service-task-form/service-task-form.module';
import { AddServiceTaskModule } from 'app/components/add-service-task/add-service-task.module';
import { RruleDateModule } from 'app/components/rrule-date/rrule-date.module';
import { TaskReorderModule } from 'app/components/task-reorder/task-reorder.module';
import { AssignEmployeeModule } from 'app/components/assign-employee/assign-employee.module';
import { CustomFieldFormModule } from 'app/components/custom-field-form/custom-field-form.module';
import { LineItemListModule } from 'app/components/line-item-list/line-item-list.module';
import { BundleDetailsModule } from 'app/components/bundle-details/bundle-details.module';

@NgModule({
  declarations: [
    JobFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DataPickerModule,
    RecurrenceScheduleModule,
    PreviewAddressFormModule,
    NewCategoryModule,
    AddressModule,
    ServiceTaskFormModule,
    AddServiceTaskModule,
    RruleDateModule,
    TaskReorderModule,
    CustomFieldFormModule,
    AssignEmployeeModule,
    LineItemListModule,
    BundleDetailsModule
  ],
  exports: [
    JobFormComponent
  ]
})
export class JobFormModule { }
